import * as _ from 'lodash';
import { Component } from 'react';
import { Dispatch, connect } from 'react-redux';
import { IBaseResponse, ICenterBase, IDonorProfileAddress, IDonorProfileAddressLookupData, IDonorProfileHeaderInfo, IVoucherHolderForList } from '@nkr/models/index';
import {
    IApplicationState, AppActionCreators,
    DonorActionCreators, IDonorProfileVoucherListResponse, AdpDonorActionCreators, IBasicCenterListResponse, CenterActionCreators, IVoucherHolderFileUploadResponse, IRecipientListByCenterResponse, RecipientActionCreators, IRecipientByCenter, IAppState,
} from '@nkr/store/index';
import VoucherHoldersGrid from './grid';
import { IBaseDispatchProps, ToggleType } from '../models';
import { downloadFile } from '@nkr/services/download-file';
import { Alert, Button } from 'react-bootstrap';
import { toast, ToastContainer, ToastOptions } from 'react-toastify';
import { VoucherHolderAction } from '@nkr/views/voucher-holder/voucher-holder-action';
import ActivateVoucher from './activate-voucher-modal';
import UploadModal from '@nkr/views/voucher-holder/modals/upload-modal';
import OrderKitConfirmationModal from '@nkr/views/voucher-holder/modals/order-kit-confirmation-modal';
import { MatchStatus } from '@nkr/enums/match-status';
import { VoucherHolderSelfRegistrationStep } from '@nkr/enums/voucher-holder-selfreg-step';

interface IOwnProps {
    donorId: number,
    centerId: number,
    isAdmin: boolean,
    isAdminLogin: boolean,
    headerInfo: IDonorProfileHeaderInfo,
    hasDataChanged: boolean,
    saveRequested: boolean,
    refreshRequested: boolean,
    onDataChanged: (hasDataChanged: boolean) => void,
    onSaveFinished: (refreshHeader: boolean) => void,
    onRefreshFinished: () => void,
    onResetDataChangedWarning: () => void,
    onTabClick: (href: string) => void,
    onUpdateForErrors: (toggleType: ToggleType, messages: string[]) => void
}

interface IStateProps {
    app: IAppState,
    groupIsSuper: boolean
}

interface IDispatchProps extends IBaseDispatchProps {
    getVouchers: (centerId: number, donorId: number) => Promise<IDonorProfileVoucherListResponse>,
    getBasicCenterList: () => Promise<IBasicCenterListResponse>,
    uploadVoucherHolderConsentForm: (voucherHolderId: number, consentFile: File) => Promise<IVoucherHolderFileUploadResponse>,
    uploadVoucherHolderSwabResults: (voucherHolderId: number, swabResultsFile: File) => Promise<IVoucherHolderFileUploadResponse>,
    uploadVoucherHolderScreeningResults: (voucherHolderId: number, screeningResultsFile: File) => Promise<IVoucherHolderFileUploadResponse>,
    orderHlaKit: (voucherHolderId: number) => Promise<IBaseResponse>,
    reorderScreening: (voucherHolderId: number) => Promise<IBaseResponse>,
    activateVoucher: (voucherHolderId: number, centerId: number, alias: string, existingRecipientId: number, isNewRecipient: boolean) => Promise<IBaseResponse>,
    downloadVoucherHolderDocument: (voucherHolderId: number, docType: number) => Promise<any>,
    resendLink: (voucherHolderId: number) => Promise<IBaseResponse>,
    getRecipientsByCenter: (centerId: number) => Promise<IRecipientListByCenterResponse>,
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    data: IVoucherHolderForList[],
    addressData: IDonorProfileAddress,
    addressLookupData: IDonorProfileAddressLookupData,
    donorDataHash: string,
    upload: {
        show: boolean,
        data: IVoucherHolderForList,
        type: VoucherHolderAction
    },
    orderKit: {
        show: boolean,
        data: IVoucherHolderForList,
        type: VoucherHolderAction
    },
    activateVoucher: {
        show: boolean,
        data: IVoucherHolderForList
    },
    centerList: ICenterBase[],
    recipientList: IRecipientByCenter[],
}

class DonorVouchers extends Component<TProps, IState> {
    readonly state: IState = {
        data: [],
        addressData: undefined,
        addressLookupData: undefined,
        upload: {
            show: false,
            data: undefined,
            type: VoucherHolderAction.Unknown
        },
        orderKit: {
            show: false,
            data: undefined,
            type: VoucherHolderAction.Unknown
        },
        activateVoucher: {
            show: false,
            data: undefined
        },
        centerList: [],
        donorDataHash: '',
        recipientList: [],
    }

    componentDidMount = () => {
        this.getData();
    }

    componentWillReceiveProps = (nextProps: Readonly<TProps>, nextContext: any) => {
        if (this.props.saveRequested == false && nextProps.saveRequested == true) {
            // this.confirmFileUploads();
        }

        if (this.props.refreshRequested == false && nextProps.refreshRequested == true) {
            this.getData();
        }
    }

    getData = () => {
        let { centerId, donorId } = this.props;

        this.props.showLoading('Getting donor data, one moment please...').then(() => {
            Promise.all([
                this.props.getVouchers(centerId, donorId),
                this.props.getBasicCenterList(),
                this.props.getRecipientsByCenter(centerId)
            ])
                .then(([voucherListResponse, centerListResponse, recipientsByCenterResponse]) => {
                    if (voucherListResponse.data.success && centerListResponse.data.success && recipientsByCenterResponse.data.success) {
                        this.setState({
                            data: voucherListResponse.data.results,
                            centerList: centerListResponse.data.results.filter(x => x.isMemberCenter),
                            recipientList: recipientsByCenterResponse.data.results
                        }, () => {
                            if (this.props.refreshRequested) {
                                this.props.onRefreshFinished();
                            }
                        });
                    }
                })
                .catch(error => {

                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    refreshList = (message: string) => {
        this.props.getVouchers(this.props.centerId, this.props.donorId)
            .then(response => {
                this.setState({
                    data: response.data.results
                });
            })
            .finally(() => {
                toast.success(message);
            });
    }

    handleAdd = () => {
        window.open('/center/' + this.props.centerId + '/donor/' + this.props.donorId + '/voucher/add', '_blank');
    }

    handleAction = (voucherHolderId: number, action: VoucherHolderAction) => {
        if (action == VoucherHolderAction.ResendLink) {
            this.handleResendLink(voucherHolderId)
        }

        if (action == VoucherHolderAction.OrderBuccalSwabKit || action == VoucherHolderAction.OrderLabScreening || action == VoucherHolderAction.ReorderLabScreening) {
            let data = this.state.data.find(x => x.id == voucherHolderId);

            this.setState({
                orderKit: {
                    show: true,
                    data,
                    type: action
                }
            });
        }

        if (action == VoucherHolderAction.UploadVoucherConsent || action == VoucherHolderAction.UploadSwabResults || action == VoucherHolderAction.UploadScreeningResults) {
            let data = this.state.data.find(x => x.id == voucherHolderId);

            this.setState({
                upload: {
                    show: true,
                    data,
                    type: action
                }
            });
        }

        if (action == VoucherHolderAction.StartRedemption) {
            let data = this.state.data.find(x => x.id == voucherHolderId);

            let showVoucherRedemptionModal = true;

            if (data.adpInformedConsentFile == '') {
                showVoucherRedemptionModal = false;

                toast.error("This voucher cannot be redeemed because the voucher holder has not uploaded the consent form.", {
                    autoClose: false,
                    position: toast.POSITION.TOP_CENTER
                });
            }

            this.setState({
                activateVoucher: {
                    show: showVoucherRedemptionModal,
                    data
                }
            });
        }
    }

    handleResendLink = (id: number) => {
        this.props.showLoading("One moment please, resending voucher holder their registration")
            .then(() => {
                this.props.resendLink(id).then((request) => {
                    let { success, message } = request.data;

                    if (success) {
                        toast.success(message);
                    } else {
                        toast.error('Unable to resend link: ' + message);
                    }
                })
            })
            .finally(() => {
                this.props.hideLoading();
            })
    }

    handleUpload = (file: File) => {
        let { data, type } = this.state.upload;
        let voucherHolderId = data.id;

        this.setState({
            upload: {
                show: false,
                data: null,
                type: VoucherHolderAction.Unknown
            }
        }, () => {
            let success = true;
            let message = '';
            let fileName = '';

            this.props.showLoading('Uploading file, one moment please...').then(async () => {
                if (type == VoucherHolderAction.UploadVoucherConsent) {
                    let response = await this.props.uploadVoucherHolderConsentForm(voucherHolderId, file);

                    success = response.data.success;
                    message = response.data.message;
                    fileName = response.data.results;
                }

                if (type == VoucherHolderAction.UploadSwabResults) {
                    let response = await this.props.uploadVoucherHolderSwabResults(voucherHolderId, file);

                    success = response.data.success;
                    message = response.data.message;
                    fileName = response.data.results;
                }

                if (type == VoucherHolderAction.UploadScreeningResults) {
                    let response = await this.props.uploadVoucherHolderScreeningResults(voucherHolderId, file);

                    success = response.data.success;
                    message = response.data.message;
                    fileName = response.data.results;
                }

                let data = _.cloneDeep(this.state.data).map(item => {
                    if (success && item.id == voucherHolderId) {
                        if (type == VoucherHolderAction.UploadVoucherConsent) {
                            item.adpInformedConsentFile = fileName;
                        }

                        if (type == VoucherHolderAction.UploadSwabResults) {
                            item.hlaSwabResultsFile = fileName;
                        }

                        if (type == VoucherHolderAction.UploadScreeningResults) {
                            item.screeningResultsFile = fileName;
                        }
                    }

                    return item;
                });

                this.setState({
                    data
                }, () => {
                    this.props.hideLoading();

                    if (success) {
                        toast.success('File uploaded successfully');
                    } else {
                        toast.error('Unable to upload file: ' + message);
                    }
                });
            });
        });
    }

    handleCancelUpload = () => {
        this.setState({
            upload: {
                show: false,
                data: null,
                type: VoucherHolderAction.Unknown
            }
        });
    }

    handleConfirmKitOrderYes = () => {
        let { data, type } = this.state.orderKit;
        let voucherHolderId = data.id;

        this.setState({
            orderKit: {
                show: false,
                data: null,
                type: VoucherHolderAction.Unknown
            }
        }, () => {
            let success = true;
            let message = '';

            this.props.showLoading('Submitting kit request, one moment please...').then(async () => {
                if (type == VoucherHolderAction.OrderBuccalSwabKit) {
                    let response = await this.props.orderHlaKit(voucherHolderId);

                    success = response.data.success;
                    message = response.data.message;
                }

                if (type == VoucherHolderAction.OrderLabScreening || type == VoucherHolderAction.ReorderLabScreening) {
                    let response = await this.props.reorderScreening(voucherHolderId)

                    success = response.data.success;
                    message = response.data.message;
                }

                this.props.hideLoading();

                if (success) {
                    toast.success('Kit request submitted successfully');
                } else {
                    toast.error('Unable to request kit: ' + message);
                }
            });
        });
    }

    handleConfirmKitOrderNo = () => {
        this.setState({
            orderKit: {
                show: false,
                data: null,
                type: VoucherHolderAction.Unknown
            }
        });
    }

    handleActivateVoucherComplete = () => {
        let voucherHolderId = this.state.activateVoucher.data.id;

        this.setState({
            activateVoucher: {
                show: false,
                data: null
            }
        }, () => {
            this.refreshList('Voucher activated successfully');
        });
    }

    handleActivateVoucherCancel = () => {
        this.setState({
            activateVoucher: {
                show: false,
                data: null
            }
        });
    }

    handleFileDownload = (voucherHolderId: number, docType: number) => {
        this.props.downloadVoucherHolderDocument(voucherHolderId, docType).then(response => {

            let fileName = "";
            if (docType == 0) {
                fileName = `voucher-consent-${voucherHolderId}`;
            }

            if (docType == 1) {
                fileName = `voucher-swab-results-${voucherHolderId}`;
            }

            if (docType == 2) {
                fileName = `voucher-screening-results-${voucherHolderId}`;
            }

            downloadFile(response.data, fileName, 'application/pdf');
        }).catch(error => {
            toast.error('Unfortunately, that file is not available', { autoClose: false });
        });
    }

    handleCenterChanged = (centerId: number) => {
        this.props.getRecipientsByCenter(centerId).then(response => {
            this.setState({
                recipientList: response.data.results
            });
        });
    }

    render = () => {
        if (this.props.headerInfo == null)
            return null;

        return (
            <>
                <div style={{ padding: 10, border: '1px solid #ccc', borderRadius: 4 }}>
                    {!this.props.headerInfo.isTransplanted && (
                        <Alert bsStyle='warning' bsSize='sm' style={{ textAlign: 'center' }}>
                            <span style={{ paddingRight: 20 }}>Voucher holders must be added BEFORE the donor donates. Voucher holders added after the donation date will not be eligible</span><Button bsStyle='primary' bsSize='sm' onClick={this.handleAdd}>Add Voucher Holder</Button>
                        </Alert>
                    )}

                    <VoucherHoldersGrid
                        data={this.state.data}
                        isAdmin={this.props.isAdmin}
                        isAdminLogin={this.props.isAdminLogin}
                        donorHasDonated={this.props.headerInfo.statusId == MatchStatus.Transplanted}
                        onAction={this.handleAction}
                        onDownload={this.handleFileDownload}
                    />
                </div>

                <UploadModal
                    show={this.state.upload.show}
                    donorAlias={this.state.upload.data != null ? this.state.upload.data.donorAlias : ''}
                    voucherHolderFullName={this.state.upload.data != null ? this.state.upload.data.firstName + ' ' + this.state.upload.data.lastName : ''}
                    type={this.state.upload.type}
                    isDonorProfile={true}
                    onUpload={this.handleUpload}
                    onCancel={this.handleCancelUpload}
                />

                <OrderKitConfirmationModal
                    show={this.state.orderKit.show}
                    donorAlias={this.state.orderKit.data != null ? this.state.orderKit.data.donorAlias : ''}
                    voucherHolderFullName={this.state.orderKit.data != null ? this.state.orderKit.data.firstName + ' ' + this.state.orderKit.data.lastName : ''}
                    type={this.state.orderKit.type}
                    onConfirmed={this.handleConfirmKitOrderYes}
                    onCancel={this.handleConfirmKitOrderNo}
                />

                <ActivateVoucher
                    show={this.state.activateVoucher.show}
                    data={this.state.activateVoucher.data}
                    centerList={this.state.centerList}
                    recipientList={this.state.recipientList}
                    onActivateVoucher={this.props.activateVoucher}
                    onComplete={this.handleActivateVoucherComplete}
                    onCenterChanged={this.handleCenterChanged}
                    onCancel={this.handleActivateVoucherCancel}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        app: appState.app,
        groupIsSuper: appState.app.user.group.isSuper
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getVouchers: (centerId, donorId) => {
            return dispatch(DonorActionCreators.getVouchers(centerId, donorId));
        },
        getBasicCenterList: () => {
            return dispatch(CenterActionCreators.getBasicCenterList(false));
        },
        uploadVoucherHolderConsentForm: (voucherHolderId, consentFile) => {
            return dispatch(AdpDonorActionCreators.uploadVoucherHolderConsentForm(voucherHolderId, consentFile));
        },
        uploadVoucherHolderSwabResults: (voucherHolderId, swabResultsFile) => {
            return dispatch(AdpDonorActionCreators.uploadVoucherHolderSwabResults(voucherHolderId, swabResultsFile));
        },
        uploadVoucherHolderScreeningResults: (voucherHolderId, screeningResultsFile) => {
            return dispatch(AdpDonorActionCreators.uploadVoucherHolderScreeningResults(voucherHolderId, screeningResultsFile));
        },
        orderHlaKit: (voucherHolderId) => {
            return dispatch(AdpDonorActionCreators.orderHlaKit(voucherHolderId));
        },
        reorderScreening: (voucherHolderId) => {
            return dispatch(AdpDonorActionCreators.reorderScreening(voucherHolderId));
        },
        activateVoucher: (voucherHolderId, centerId, alias, existingRecipientId, isNewRecipient) => {
            return dispatch(AdpDonorActionCreators.activateVoucher(voucherHolderId, centerId, alias, existingRecipientId, isNewRecipient));
        },
        downloadVoucherHolderDocument: (voucherHolderId, docType) => {
            return dispatch(AdpDonorActionCreators.downloadVoucherHolderDocument(voucherHolderId, docType));
        },
        getRecipientsByCenter: (centerId) => {
            return dispatch(RecipientActionCreators.getByCenter(centerId));
        },
        resendLink: (voucherHolderId) => {
            return dispatch(AdpDonorActionCreators.resendVoucherLink(voucherHolderId))
        },
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(DonorVouchers);
